import React, { useState, useEffect } from 'react';
import { httpss } from '../utils/host'; // Đảm bảo httpss được import đúng

export default function ListPage() {
  const [userId, setUserId] = useState(null); // Lưu Facebook User ID
  const [accessToken, setAccessToken] = useState(null); // Lưu Access Token
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Kiểm tra trạng thái đăng nhập
  const [error, setError] = useState(null); // Lưu lỗi nếu có

  useEffect(() => {
    // Load Facebook SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '1303634020222700', // replace with your Facebook app ID
        cookie: true,
        xfbml: true,
        version: 'v20.0',
      });
    };
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/vi_VN/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }, []);

  // Hàm xử lý đăng nhập
  const handleLogin = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          // Trích xuất access token
          const token = response.authResponse.accessToken;
          setAccessToken(token);

          // Lấy Facebook User ID từ Graph API
          window.FB.api('/me', { fields: 'id,name' }, async (user) => {
            console.log('User logged in:', user);
            setUserId(user.id);
            setIsLoggedIn(true);
            await handlePostIDFB(user.id, token);
          });
        } else {
          setError('User cancelled login or did not fully authorize.');
        }
      },
      {
        // { scope: "public_profile" }
        scope:
          'pages_show_list,ads_management,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_engagement',
      }
    );
  };

  // Hàm gửi yêu cầu tới server
  const handlePostIDFB = async (userId, accessToken) => {
    try {
      const res = await fetch(`${httpss}/apis_v1/dashboard/dataListPage`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: userId,
          accessToken: accessToken,
        }),
      });

      if (res.ok) {
        const data = await res.json();
        console.log('Server Response:', data);
      } else {
        console.error('Error sending data to server:', res.status);
      }
    } catch (err) {
      console.error('Error:', err);
    }
  };

  return (
    <div className="max-w-lg mx-auto p-5 bg-white rounded-lg shadow-lg mt-10">
      <div className="text-center">
        <h1 className="text-2xl font-semibold text-gray-800 mb-4">Facebook Login</h1>
      </div>

      {!isLoggedIn && (
        <div className="flex justify-center">
          <button
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition duration-300"
            onClick={handleLogin}
          >
            Đăng nhập Facebook
          </button>
        </div>
      )}

      {isLoggedIn && (
        <div className="text-center p-6 bg-gray-100 rounded-lg shadow-md">
          <p className="text-xl text-green-600 mb-4">Chào mừng, bạn đã đăng nhập thành công!</p>
          <p className="text-gray-800">Facebook User ID: {userId}</p>
          <button
            className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition duration-300 mt-4"
            onClick={() => handlePostIDFB(userId, accessToken)}
          >
            Gửi ID đến server
          </button>
        </div>
      )}

      {error && <p className="text-red-500 text-center mt-4">{error}</p>}
    </div>
  );
}
